export const constantRoutes = [
  {
    path: '/login',
    component: () => import('@/view/login/index.vue'),
    meta: {
      title: '登入'
    }
  },
  {
    path: '/404',
    component: () => import('@/view/error-page/404.vue'),
    meta: {
      title: '404'
    }
  },
  {
    path: '/401',
    component: () => import('@/view/error-page/401.vue'),
    meta: {
      title: '401'
    }
  },
  {
    path: '/',
    component: () => import('@/layout/index.vue'),
    redirect: '/home',
    children: [
      {
        path: '/home',
        component: () => import('@/view/single-page/home/index.vue'),
        name: 'home',
        meta: { title: 'home', icon: 'el-icon-s-home', affix: true }
      },
      {
        path: '/about',
        component: () => import('@/view/single-page/about/index.vue'),
        name: 'about',
        meta: { title: 'about', icon: 'el-icon-star-on' }
      }
    ]
  },
];

export const asyncRoutes = []